var canvas, canvas2, text, newText, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,
    placeholderimg1, placeholderimg2, currentSignature,
    placeholderimg4,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var outLine,sizeBmW = 715, sizeBmH = 450,
    sizeB0W = 450, sizeB0H = 292,
    sizeB1W = 170, sizeB1H = 70;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let backImg = document.querySelector("#background_birthday");
let bg_img = new fabric.Image(backImg, {
  left: 0,   
  top: 0,
  scaleX: 1.97,
  scaleY: 1.97,
  selectable: false
});

let frameImg = document.querySelector("#design_birthday");
let simpleImage = new fabric.Image(frameImg, {
  left: 270,   
  top: 400,
  scaleX: 1.15,
  scaleY: 1.15,
  selectable: false
});
window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

window['canvas2'].add(bg_img);
bg_img.sendToBack();
window['canvas2'].add(simpleImage);
simpleImage.bringToFront();
addModify(window['canvas2']);



let currentImgInstance = null; 


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const defaultImgUrl = document.getElementById('image_preview')?.src;
    const canvas = window['canvas2'];
    const placeholder = window['placeholderimg0'];

    if (defaultImgUrl && canvas && placeholder) {
      fabric.Image.fromURL(defaultImgUrl, function (imgInstance) {
        imgInstance.set({
          left: placeholder.left,
          top: placeholder.top,
          scaleX: placeholder.width / imgInstance.width,
          scaleY: placeholder.height / imgInstance.height,
          selectable: false
        });

        imgInstance.bringToFront();
        canvas.add(imgInstance);
        canvas.renderAll();

        currentImgInstance = imgInstance;
      });
    }
  }, 300); // Wait for canvas and elements to be ready
});


window['placeholderimg0'] = new fabric.Rect({
  left: 680,
  top: 615,
  width: sizeB0W,
  height: sizeB0H,
  fill: 'rgba(0,0,0,0)'
});

window['placeholderimg1'] = new fabric.Rect({
  left: 565,
  top: 1257,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 5,
  ry: 5
});

window['placeholderimg2'] = new fabric.Rect({
  left: 797,
  top: 1257,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)',
  rx: 5,
  ry: 5
});


window['canvas2'].add(window['placeholderimg0'], window['placeholderimg1'], window['placeholderimg2']);


document.getElementById('image_upload_logo').addEventListener('change', function(e) {
  canvas = window['canvas2'];
  available_height = sizeB0H;
  img = window['placeholderimg0'];
  outline = window['border0'];
  sizeCrop = '1.54';

  if (currentImgInstance) {
    canvas.remove(currentImgInstance);
    currentImgInstance = null;
  }
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height', available_height);
  readURL2(e.target, '#image0');
});


document.getElementById('image_upload_first').addEventListener('change',function(e){
   canvas = window['canvas2'];
   img = window['placeholderimg1'];
   outline = window['border1'];
   available_height = img.height;
   sizeCrop = '2.43';
   reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
   readURL2(e.target);
 });

document.getElementById('image_upload_second').addEventListener('change',function(e){
  canvas = window['canvas2'];
  img = window['placeholderimg2'];
  outline = window['border2'];
  available_height = img.height;
  sizeCrop = '2.43';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});


window['text1Page'] = new fabric.Text('2025',{
  left: 680,
  top: 1180,
  fontSize: 45,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === '2025') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 45; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 120);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});




window['text2Page'] = new fabric.Text('BEST GOLD SHOP OF THE YEAR',{
  left: 680,
  top: 820,
  fontSize: 38,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text2Page']);

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'BEST GOLD SHOP OF THE YEAR') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 38; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_2').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text2Page'].set('text', newText);
  fitTextToWidth(window['text2Page'], 650);
  window['text2Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text3Page'] = new fabric.Text('AWARDED TO',{
  left: 680,
  top: 920,
  fontSize: 38,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text3Page']);



var maxWidth = 550;
var maxHeight = 100;

var para = "HAJI NOOR MUHAMMAD\nHAJI ABDUL SALAM JEWELLERS KOHAT" ;

window['text4Page'] = new fabric.Text(para,{
  left: 680,
  top: 1020,
  width: 550,
  fontSize: 33,
  lineHeight: 1,
  fontFamily: 'Arial',
  textAlign: 'center',
  isWrapping: true,
  fill: '#000'
});

var fontName2 = window['text4Page'].fontFamily;
jQuery('.choose_font').val("'" + fontName2 + "'").trigger('change');

window['canvas2'].add(window['text4Page']);


var minFontSize = 10;
var maxFontSize = 36;

// Clear text on input focus if default
document.getElementById('text_4').addEventListener('focus', function () {
  if (window['text4Page'].text === 'HAJI NOOR MUHAMMAD\nHAJI ABDUL SALAM JEWELLERS KOHAT') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText2(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_4').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text4Page'].set({
    text: input
  });
  fitTextToBox(window['text4Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}


window['text5Page'] = new fabric.Text('Manager',{
  left: 560,
  top: 1330,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text5Page']);


window['text6Page'] = new fabric.Text('CEO',{
  left: 790,
  top: 1330,
  fontSize: 24,
  fontFamily: 'Arial',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text6Page']);



function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  jQuery(window).on('load',function(){
    canvasBlock(canvas);
  });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler() {
  var activeOb = window['canvas2'].getActiveObject();
  if (activeOb) {
    window['canvas2'].remove(activeOb);
    window['canvas2'].renderAll();
  }
}


initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
        clipPath: new fabric.Rect({
          width: img.width,
          height: img.height,
          rx: 20, // Apply border radius from placeholder
          ry: 20
        })
      });
    };
  };
  reader.readAsDataURL(file);
}

let currentUploadedImages = {
  logo: null,
  first: null,
  second: null
};
window['placeholderimg0'].objKey = "logo";
window['placeholderimg1'].objKey = "first";
window['placeholderimg2'].objKey = "second";

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  // Remove old uploaded image for this placeholder if exists
  if(currentUploadedImages[img.objKey]) {
    canvas.remove(currentUploadedImages[img.objKey]);
  }

  fabric.Image.fromURL(imgurl, function(newImg){
    const scale = newImg.width / img.width;
    newImg.set({
      left: img.left,
      top: img.top,
      originX: 'center',
      originY: 'center'
    });
    newImg.scaleToHeight(available_height);

    // Clip with rounded corners
    const clipPath = new fabric.Rect({
      width: newImg.width,
      height: newImg.height,
      rx: img.rx * scale,
      ry: img.ry * scale,
      left: 0,
      top: 0,
      originX: 'center',
      originY: 'center',
      fill: 'transparent'
    });
    newImg.clipPath = clipPath;

    // Add new image
    canvas.add(newImg);
    canvas.bringToFront(outline);

    // Save reference (important!)
    currentUploadedImages[img.objKey] = newImg;

    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});




// keep signature reference globally
var currentSignature = null;


$(document).ready(function() {
  // Signature pad canvas
  var managersignatureCanvas = new fabric.Canvas('managersignatureCanvas', {
    isDrawingMode: true
  });
  managersignatureCanvas.freeDrawingBrush.color = "black";
  managersignatureCanvas.freeDrawingBrush.width = 2;

  // On submit
  $("#submitDrawing").on("click", function(e) {
    e.preventDefault();

    if (managersignatureCanvas.isEmpty()) {
      alert("Please draw your signature before submitting.");
      return;
    }

    var signatureData = managersignatureCanvas.toDataURL("image/png");

    fabric.Image.fromURL(signatureData, function(managsign) {
      if (currentSignature) {
        window['canvas2'].remove(currentSignature);
      }

      managsign.set({
        left: 560,
        top: 1260,
        scaleX: 0.6,
        scaleY: 0.6,
        hasControls: true,
        hasBorders: true,
        selectable: true
      });

      window['canvas2'].add(managsign).setActiveObject(managsign);
      currentSignature = managsign; // ✅ global reference
      window['canvas2'].renderAll();

      // Once user deselects, make it unselectable
      window['canvas2'].on('selection:cleared', function() {
        if (currentSignature) {
          currentSignature.selectable = true;
          currentSignature.hasControls = true;
          currentSignature.hasBorders = true;
          window['canvas2'].renderAll();
        }
      });
      
    });

    managersignatureCanvas.clear();
  });
});




$(document).ready(function () {
  // Hide both by default, then show upload section
  $(".manager_signature_image, .manually_manager_signature").hide();
  $(".manager_signature_image").show();

  $("#manager_signature").on("change", function () {
    var value = $(this).val();

    if (value === "upload") {
      // Show upload, hide manual
      $(".manager_signature_image").show();
      $(".manually_manager_signature").hide();

      // Show placeholders
      if (window['placeholderimg0']) window['placeholderimg0'].set({ visible: true });
      if (window['placeholderimg1']) window['placeholderimg1'].set({ visible: true });

      if (typeof currentUploadedImages.first !== "undefined" && currentUploadedImages.first) currentUploadedImages.first.set({ visible: true });


      // Hide signature
      if (typeof currentSignature !== "undefined" && currentSignature) {
        currentSignature.set({ visible: false });
      }

    } else if (value === "manual") {
      // Show manual, hide upload
      $(".manually_manager_signature").show();
      $(".manager_signature_image").hide();

      // Hide placeholders
      if (window['placeholderimg0']) window['placeholderimg0'].set({ visible: true });
      if (window['placeholderimg1']) window['placeholderimg1'].set({ visible: false });

      if (typeof currentUploadedImages.first !== "undefined" && currentUploadedImages.first) currentUploadedImages.first.set({ visible: false });


      // Show signature
      if (typeof currentSignature !== "undefined" && currentSignature) {
        currentSignature.set({ visible: true });
      }
    }

    window['canvas2'].renderAll();
  });
});





// keep signature reference globally
var CeoSignature = null;


$(document).ready(function() {
  // Signature pad canvas
  var ceosignatureCanvas = new fabric.Canvas('ceosignatureCanvas', {
    isDrawingMode: true
  });
  ceosignatureCanvas.freeDrawingBrush.color = "black";
  ceosignatureCanvas.freeDrawingBrush.width = 2;

  // On submit
  $("#submitDrawingceo").on("click", function(e) {
    e.preventDefault();

    if (ceosignatureCanvas.isEmpty()) {
      alert("Please draw your signature before submitting.");
      return;
    }

    var signatureData2 = ceosignatureCanvas.toDataURL("image/png");

    fabric.Image.fromURL(signatureData2, function(managsign2) {
      if (CeoSignature) {
        window['canvas2'].remove(CeoSignature);
      }

      managsign2.set({
        left: 790,
        top: 1260,
        scaleX: 0.6,
        scaleY: 0.6,
        hasControls: true,
        hasBorders: true,
        selectable: true
      });

      window['canvas2'].add(managsign2).setActiveObject(managsign2);
      CeoSignature = managsign2; // ✅ global reference
      window['canvas2'].renderAll();

      // Once user deselects, make it unselectable
      window['canvas2'].on('selection:cleared', function() {
        if (CeoSignature) {
          CeoSignature.selectable = true;
          CeoSignature.hasControls = true;
          CeoSignature.hasBorders = true;
          window['canvas2'].renderAll();
        }
      });
      
    });

    ceosignatureCanvas.clear();
  });
});




$(document).ready(function () {
  // Hide both by default, then show upload section
  $(".ceo_signature_image, .manually_ceo_signature").hide();
  $(".ceo_signature_image").show();

  $("#ceo_signature").on("change", function () {
    var value = $(this).val();

    if (value === "ceoupload") {
      // Show upload, hide manual
      $(".ceo_signature_image").show();
      $(".manually_ceo_signature").hide();

      // Show placeholders
      if (window['placeholderimg0']) window['placeholderimg0'].set({ visible: true });
      if (window['placeholderimg2']) window['placeholderimg2'].set({ visible: true });

      if (typeof currentUploadedImages.second !== "undefined" && currentUploadedImages.second) currentUploadedImages.second.set({ visible: true });


      // Hide signature
      if (typeof CeoSignature !== "undefined" && CeoSignature) {
        CeoSignature.set({ visible: false });
      }

    } else if (value === "ceomanual") {
      // Show manual, hide upload
      $(".manually_ceo_signature").show();
      $(".ceo_signature_image").hide();

      // Hide placeholders
      if (window['placeholderimg0']) window['placeholderimg0'].set({ visible: true });
      if (window['placeholderimg2']) window['placeholderimg2'].set({ visible: false });

      if (typeof currentUploadedImages.second !== "undefined" && currentUploadedImages.second) currentUploadedImages.second.set({ visible: false });


      // Show signature
      if (typeof CeoSignature !== "undefined" && CeoSignature) {
        CeoSignature.set({ visible: true });
      }
    }

    window['canvas2'].renderAll();
  });
});





jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  fontFamily = jQuery(this).val();
  canvas.renderAll();
  updateFont(window['text1Page'],fontFamily);
  updateFont(window['text2Page'],fontFamily);
  updateFont(window['text3Page'],fontFamily);
  updateFont(window['text4Page'],fontFamily);
  fitTextToWidth(window['text1Page'], 120);
  fitTextToWidth(window['text2Page'], 650);
  fitTextToBox(window['text4Page'], maxWidth, maxHeight);
});



function updateFont(activeOb,family){
  if(activeOb){
    if(family == ''){
      family = activeOb.fontFamily;
    }
    sCAle = activeOb.scaleX;
    activeOb.set('fontFamily',family);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}


jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});



async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
var size,thumbnail;
var loadedObject,enterYear,enterHeading,enterDetails,chooseFont,mngSignature,ceoSignature,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    canvas.remove(bg_img);
    window['canvas2'] = canvas.toDataURL('image/png');
    enterYear = jQuery('.enter_year input').val();
    enterHeading = jQuery('.enter_heading input').val();
    enterDetails = jQuery('.enter_details textarea').val();
    chooseFont = jQuery('.choose_font option:selected').val();
    mngSignature = jQuery('#manager_signature option:selected').val();
    ceoSignature = jQuery('#ceo_signature option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#enterYear').val(enterYear);
      jQuery('#enterHeading').val(enterHeading);
      jQuery('#enterDetails').val(enterDetails);
      jQuery('#chooseFont').val(chooseFont);
      jQuery('#mngSignature').val(mngSignature);
      jQuery('#ceoSignature').val(ceoSignature);
      jQuery('#addInfo').val(additionalInfo);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});


function resizeObjects(canvas) {
  let objectsToGroup = [];

  // ✅ Add text fields if exist
  for (let i = 1; i <= 6; i++) {
    if (window[`text${i}Page`]) {
      window[`text${i}Page`].setCoords();
      objectsToGroup.push(window[`text${i}Page`]);
    }
  }

  // ✅ Add signatures if exist
  if (typeof currentSignature !== 'undefined' && currentSignature) {
    currentSignature.setCoords();
    objectsToGroup.push(currentSignature);
  }
  if (typeof CeoSignature !== 'undefined' && CeoSignature) {
    CeoSignature.setCoords();
    objectsToGroup.push(CeoSignature);
  }

  // ✅ Add uploaded images from currentUploadedImages
  if (typeof currentUploadedImages !== 'undefined') {
    Object.keys(currentUploadedImages).forEach(key => {
      if (currentUploadedImages[key]) {
        currentUploadedImages[key].setCoords();
        objectsToGroup.push(currentUploadedImages[key]);
      }
    });
  }

  // ✅ Add placeholder / static images
  if (typeof simpleImage !== 'undefined' && simpleImage) {
    simpleImage.setCoords();
    objectsToGroup.push(simpleImage);
  }
  if (typeof currentImgInstance !== 'undefined' && currentImgInstance) {
    currentImgInstance.setCoords();
    objectsToGroup.push(currentImgInstance);
  }
  if (typeof img !== 'undefined' && img) {
    img.setCoords();
    objectsToGroup.push(img);
  }
  if (typeof placeholderimg1 !== 'undefined' && placeholderimg1) {
    placeholderimg1.setCoords();
    objectsToGroup.push(placeholderimg1);
  }
  if (typeof placeholderimg2 !== 'undefined' && placeholderimg2) {
    placeholderimg2.setCoords();
    objectsToGroup.push(placeholderimg2);
  }

  
  if (objectsToGroup.length === 0) return;


  var designResiz = new fabric.Group(objectsToGroup, {
    left: halfWidth,
    top: halfHeight,
    originX: 'center',
    originY: 'center'
  });


  designResiz.scaleToWidth(1300);
  designResiz.setCoords();

  canvas.renderAll();
}



function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(bg_img);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}